<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : bom.pkid ? '编辑' : '新建'"
      width="1200px"
      class="adaptationModal"
      @close="$reset('form')"
  >
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="bom"
        :rules="ruleValidate"
        class="form"
        :disabled="disabled"
        label-width="120px">
      <div class="editTitle">基本信息</div>
      <el-row>
        <!--        <el-col v-if="bom.pkid" :span="12">-->
        <!--          <el-form-item label="编号" prop="bomNo">-->
        <!--            <el-input v-model="bom.bomNo" disabled/>-->
        <!--          </el-form-item>-->
        <!--        </el-col>-->
        <!--        <el-col :span="12">-->
        <!--          <el-form-item label="BOM类型" prop="bomType">-->
        <!--            <el-select v-model="bom.bomType" placeholder="请选择BOM类型">-->
        <!--              <el-option label="销售BOM" :value="10"/>-->
        <!--              <el-option label="生产BOM" :value="20"/>-->
        <!--            </el-select>-->
        <!--          </el-form-item>-->
        <!--        </el-col>-->
        <el-col :span="6">
          <el-form-item label="物料编号：" prop="materialNo">
            <span>{{bom.materialNo}}</span>
            <!--            <el-input v-model="bom.materialNo" readonly placeholder="请选择物料">-->
            <!--              <el-button slot="append" icon="el-icon-search" @click="$refs.materialSelect.open()"/>-->
            <!--            </el-input>-->
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item label="物料名称：" prop="materialName">
            <span>{{bom.materialName}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle" style="display: flex; justify-content: space-between;">
        <span>子物料信息</span>
        <div style="display: flex; flex-wrap: wrap;gap: 30px;">
          <div>
            关键物料个数：<span style="color: #2d8cf0; font-weight: 600;">{{keyMaterialCount}}</span>
          </div>
          <div>
            关键物料总数量：<span style="color: #2d8cf0; font-weight: 600;">{{keyMaterialQuantity}}</span>
          </div>
          <div>
            包装物料个数：<span style="color: #2d8cf0; font-weight: 600;">{{packMaterialCount}}</span>
          </div>
        </div>
      </div>
      <!--      <el-button type="primary" style="margin-bottom: 8px" @click="$refs.childMaterialSelect.open()"> 添加 </el-button>-->
      <el-table
          ref="elTable"
          v-loading="contentLoading"
          :data="bom.bomDetails"
          row-key="pkid"
          border
          stripe
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
        <el-table-column prop="materialNo" label="物料编号" width="160"/>
        <el-table-column prop="materialName" label="物料名称"/>
        <el-table-column prop="quantity" label="数量" width="80"/>
        <el-table-column prop="unit" label="单位" width="80"/>
        <el-table-column prop="action" label="关键物料" width="80">
          <template slot-scope="{ row }">
            <el-switch
                v-model="row.keyMaterial"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="true"
                :inactive-value="false"
                @change="(val) => handleChange(row, val, 'keyMaterial')"/>
          </template>
        </el-table-column>
        <el-table-column prop="packMaterial" label="包装物料" width="80">
          <template slot-scope="{ row }">
            <el-switch
                v-model="row.packMaterial"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="true"
                :inactive-value="false"
                @change="(val) => handleChange(row, val, 'packMaterial')"/>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
    <material-select ref="materialSelect" @select="materialSelect"/>
    <child-material-select ref="childMaterialSelect" @select="childMaterialSelect"/>
  </el-dialog>
</template>

<script>
  import MaterialSelect from "@/views/information/Material/MaterialSelect";
  import ChildMaterialSelect from "@/views/information/Material/MaterialSelect";

  export default {
    components: {
      MaterialSelect,
      ChildMaterialSelect,
    },
    data() {
      return {
        disabled: false,
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        bom: {
          pkid: 0,
          bomType: "",
          materialName: "",
          materialID: "",
          bomDetails: [],
        },
        ruleValidate: {
          // bomType: { required: true, message: "请选择BOM类型", trigger: "change" },
          // materialName: { required: true, message: "请选择物料", trigger: "change" },
        },
      };
    },
    computed: {
      keyMaterialCount() {
        let count = 0;
        const countNode = (list) => {
          list.forEach((item) => {
            if (item.keyMaterial) {
              count++;
            }
            if (item.children && item.children.length > 0) {
              countNode(item.children);
            }
          });
        };
        countNode(this.bom.bomDetails);
        return count;
      },
      keyMaterialQuantity() {
        let quantity = 0;
        const sumQuantity = (list) => {
          list.forEach((item) => {
            if (item.keyMaterial && item.quantity) {
              quantity += Number(item.quantity);
            }
            if (item.children && item.children.length > 0) {
              sumQuantity(item.children);
            }
          });
        };
        sumQuantity(this.bom.bomDetails);
        return quantity;
      },
      packMaterialCount() {
        let count = 0;
        const countNode = (list) => {
          list.forEach((item) => {
            if (item.packMaterial) {
              count++;
            }
            if (item.children && item.children.length > 0) {
              countNode(item.children);
            }
          });
        };
        countNode(this.bom.bomDetails);
        return count;
      },
    },
    methods: {
      open(row, mark) {
        this.dialogVisible = true;
        this.disabled = mark;
        if (row) {
          // this.getBomInfoByID(row.pkid);
          this.getBomInfoByMaterialNo(row.materialNo);
        }
      },

      materialSelect(row) {
        this.bom.materialName = row.name;
        this.bom.materialID = row.id;
      },

      getBomInfoByID(pkid) {
        this.contentLoading = true;
        this.$http
          .get("basic", `boms/${pkid}`)
          .then((resp) => {
            if (resp.success) {
              this.bom = Object.assign(this.bom, resp.data);
              this.bom.materialID = resp.data.materialId;
            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      getBomInfoByMaterialNo(materialNo) {
        this.contentLoading = true;
        this.$http
          .get("basic", `sapBoms/${materialNo}`)
          .then((resp) => {
            if (resp.success) {
              this.bom =  resp.data;
            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      childMaterialSelect(row) {
        const arr = this.bom.bomDetails.filter((item) => row.materialID === item.partsId);
        if (arr.length) {
          this.$confirm("物料已存在，请勿重复添加", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          const item = {
            partsId: row.id,
            materialName: row.name,
            materialNo: row.no,
            unit: row.unit,
            quantity: 1,
          };
          this.bom.bomDetails.push(item);
        }
      },

      quantityHandle(row, index) {
        this.$set(this.bom.bomDetails, index, row);
      },

      handleSubmit() {
        this.submitLoading = true;
        this.$http.post("basic", "bomKeyMaterials/saveKeyMaterial", this.bom)
          .then((resp) => {
            if (resp.success) {
              this.$message.success("保存成功");
            }
          }).catch((e) => {
            this.$message.error(e);
          }).finally(() => {
            this.submitLoading = false;
            this.dialogVisible=false;
          });
      },

      handleChange(row, val, type) {
        const updateNode = (list) => {
          for (let i = 0; i < list.length; i++) {
            if (list[i].materialNo === row.materialNo) {
              this.$set(list[i], type, val);
              return true;
            }
            if (list[i].children && list[i].children.length > 0) {
              if (updateNode(list[i].children)) {
                return true;
              }
            }
          }
          return false;
        };
        updateNode(this.bom.bomDetails);
      },
    },
  };
</script>
